module.exports = __webpack_public_path__ + "static/media/Isaac.ffcc7c15.JPG";